"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CodeSnippet;

var _react = _interopRequireDefault(require("react"));

var _useClassBuilder = _interopRequireDefault(require("../../hooks/useClassBuilder"));

var _useStyleBuilder = _interopRequireDefault(require("../../hooks/useStyleBuilder"));

var _ = require("../");

var _reactSyntaxHighlighter = require("react-syntax-highlighter");

var _jsx = _interopRequireDefault(require("react-syntax-highlighter/dist/esm/languages/prism/jsx"));

var _prism = require("react-syntax-highlighter/dist/esm/styles/prism");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*---------------------------------------------*/
var BASE_CLASS = 'lth-c-codesnippet';
/*---------------------------------------------*/

function CodeSnippet(props) {
  var content = props.code || props.children;

  if (_typeof(content) === 'object' && content.join) {
    content = content.join('\n'); // multi-line support
  }

  var Highlighter = _reactSyntaxHighlighter.PrismLight;

  if (props.language === 'jsx') {
    Highlighter.registerLanguage('jsx', _jsx.default);
  }

  var codeStyle = {
    fontFamily: 'var(--typography-font-family-monospace)',
    fontSize: 'var(--typography-body-regular-size)',
    padding: 'var(--space-inset-m)',
    background: 'transparent'
  };
  var classes = (0, _useClassBuilder.default)(props, BASE_CLASS);
  var style = (0, _useStyleBuilder.default)(props);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    style: style
  }, /*#__PURE__*/_react.default.createElement(Highlighter, {
    customStyle: codeStyle,
    language: props.language || 'html',
    style: _prism.vs
  }, content), /*#__PURE__*/_react.default.createElement(_.IconButton, {
    className: BASE_CLASS + '__copybutton',
    icon: "copy",
    onClick: function onClick() {
      return onCopy(content);
    }
  }));

  function onCopy(content) {
    navigator.clipboard.writeText(content);
    props.onCopy && props.onCopy(content);
  }
}
/*---------------------------------------------*/


CodeSnippet.METADATA = {
  name: 'CodeSnippet',
  props: [{
    name: 'language',
    type: 'string'
  }, {
    name: 'code',
    type: 'longtext'
  }, {
    name: "onCopy",
    type: "function"
  }],
  demo: {
    content: '<div class="button">Start</div>'
  }
};